/* istanbul ignore file */
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { RecruitmentListLayout } from '@/components/layout/recruitmentList/RecruitmentListLayout';
import { RecruitmentListPlayersLayout } from '@/components/layout/recruitmentList/RecruitmentListPlayersLayout';
import { NotFound } from '@/pages/NotFound';
import { RecruitmentListOverviewPage } from '@/pages/recruitmentList/overview/RecruitmentListOverviewPage';
import { RecruitmentListPlayers } from '@/pages/recruitmentList/RecruitmentListPlayers/RecruitmentListPlayers';

export const RecruitmentListRoutes = () => (
  <Routes>
    <Route element={<RecruitmentListLayout />}>
      <Route path="overview" element={<RecruitmentListOverviewPage />} />
    </Route>
    <Route path=":recruitmentListId" element={<RecruitmentListPlayersLayout />}>
      <Route path="players" element={<RecruitmentListPlayers />} />
    </Route>

    <Route path="*" element={<NotFound />} />
  </Routes>
);
